import React from 'react';

import utils, { statuses } from './Utils';
/* import ShareSVG from '../images/share.svg'; */
import CleanSVG from '../images/clean.inline.svg';
import DeepfakeSVG from '../images/deepfake.inline.svg';
import PlaySVG from '../images/play.inline.svg';
import GaugeChart from 'react-gauge-chart';
import Utils from './Utils';
import ProgressBar from 'react-bootstrap/ProgressBar';

const StatusIcon = ({ status }) => {
  let color = utils.getColorbyStatus(status);
  let iconStyle = { color: color, fill: color };
  switch (status) {
    case statuses.DEEPFAKE:
      return (
        <DeepfakeSVG
          className="col-xs-1 status-icon"
          style={iconStyle}
        ></DeepfakeSVG>
      );

    case statuses.SUSPICIOUS:
      return (
        <DeepfakeSVG
          className="col-xs-1 status-icon"
          style={iconStyle}
        ></DeepfakeSVG>
      );
    case statuses.CLEAN:
      return (
        <CleanSVG className="col-xs-1 status-icon" style={iconStyle}></CleanSVG>
      );
    default:
      return null;
  }
};

const StatusRow = ({ title, text, pClass }) => (
  <div className="col-xs-12 status-row">
    <label>{title}</label>
    <p className={pClass}>{text ? text : '-'}</p>
  </div>
);

const StatusField = ({ title, text, size }) => (


  <div className={`col-sm-${size} sum-field`}>
    <p>{text ? text : '-'}</p>
    <div className="light">{title}</div>
  </div>
);
const chartStyle = {
  // height: 80,
  width: 165
}
const getScore = (report, threshold) => {

  //let score = report?.results?.deepware?.score;
  let score = 50;

  if (report?.results?.Analyst != undefined) {
    score = report?.results["Analyst"]?.score
  }
  else if (report?.results?.final != undefined) {

    score = report?.results["final"]?.score

  }
  else {
    score = report?.results["deepware"]?.score

  }


  let th1 = 50
  let th2 = 51
  let th3 = 79
  let th4 = 80
  if (threshold != undefined) {
    th1 = threshold?.green[1];
    th2 = threshold?.yellow[0];
    th3 = threshold?.yellow[1];
    th4 = threshold?.red[0];
  }

  if (0 <= score && score <= th1) {
    score = .15;
  }
  if (th2 <= score && score <= th3) {
    score = .50;
  }
  if (th4 <= score) {
    score = .85;
  }
  return score;
};


const StatusPanel = ({ status, report, threshold, handleShowScanner, btnText }) => (
  <div className="panel panel-default status-panel col-xs-12">
    <>{(report.completed === false && report.progress > 0 && report.progress < 100) && <ProgressBar className="result-progress" animated striped variant="info" now={report.progress} />}</>
    <div
      style={{ color: utils.getColorbyStatus(status) }}
      className="panel-heading status-header col-xs-12"
    >
      <StatusIcon status={status} report={report} />
      <div
        // className={`col-xs-${status === statuses.ONQUEUE ||
        //   status === statuses.ENQUEUING ||
        //   status === statuses.SCANNING ||
        //   status === statuses.FAILED
        //   ? '10 p-l-25'
        //   : '9'
        //   } m-y-auto`}
        className="col-xs-6 col-md-10 m-y-auto statusText"
      >
        <>{utils.getStatusText(status, report)}</>
        <>{(report.completed === false && report.progress > 0 && report.progress < 100) && <small> {report.progress}% - {report.status}</small>}</>
      </div>
      <div  className="col-xs-5 col-md-3 p-r-25">
      <button onClick={() => handleShowScanner()} className="btnShow">
        {btnText==="" ?"New Scan":"Close"}  
        
     </button>
     </div>
    </div>
    <div className="panel-body col-xs-12">

      <div className="col-xs-12 col-md-2 p-0 ">
        <GaugeChart id="gauge-chart1" style={chartStyle}
          colors={['#5BE12C', '#F5CD19', '#EA4228']}
          percent={
            getScore(report, threshold)

          }

          hideText={true} />
      </div>

      <div className="row p-0 m-0">

        <div className="col-xs-6 col-md-5 p-0 ">
          <StatusRow
            title="Name:"
            text={report?.names?.[0]}
            
          />
          <StatusRow title="Size:" text={utils.videoSize(report?.size)} />
        </div>
        <div className="col-xs-6 visible-xs-block visible-sm-block">
          <StatusRow
            title="Source:"
            text={utils.isYT(report?.names?.[0]) ? 'Youtube' : 'User'}
          />
          <StatusRow title="Type:" text={report?.type} />
        </div>
        {/* <div className="clearfix visible-xs-block visible-sm-block"></div> */}

        <div className="col-xs-12 visible-xs-block visible-sm-block p-t-15 text-center">
          <div>{utils.submittedOn(report?.['report-id'])}</div>
          <div className="block light">
            {utils.submittedTimeAgo(report?.['report-id'])}
          </div>
        </div>
        <div className="col-md-5 visible-md-block visible-lg-block p-0">
          <StatusField
            size="3"
            title="Source"
            text={utils.isYT(report?.names?.[0]) ? 'Youtube' : 'User'}
          />

          <StatusField
            size="6"
            title={utils.submittedTimeAgo(report?.['report-id'])}
            text={utils.submittedOn(report?.['report-id'])}
          />
        </div>
      </div>
    </div>
  </div>
);

export default StatusPanel;
